import { gql } from '@apollo/client';

const AUTH_USER_FIELDS = `
  id
  name
  email
  role
`;

export const LOGIN = gql`
  mutation Login($email: String!) {
    login(input: { email: $email }) {
      user {
        ${AUTH_USER_FIELDS}
      }
    }
  }
`;

export const LOGIN_CODE = gql`
  mutation LoginCode($email: String!, $code: String!) {
    loginCode(input: { email: $email, code: $code }) {
      user {
        ${AUTH_USER_FIELDS}
      }
    }
  }
`;

export const LOGOUT = gql`
  mutation Logout {
    logout(input: {}) {
      success
    }
  }
`;
